import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  uploadPhoto: {
    color: '#00588f',
  },
  subtitle: {
    marginTop: theme.spacing(2),
    lineHeight: 1.5,
    fontSize: '1.15em',
  },
  inputField: {
    display: 'block',
    maxWidth: 362,
    marginBottom: theme.spacing(2),
  },
  countryField: {
    maxWidth: 362,
  },
  gdpr: {
    marginTop: theme.spacing(7),
    lineHeight: 1.5,
    fontSize: '1.15em',
  },
  gdprr: {
    color: '#00588f',
  },
}));
